<div class="jumbotron" id="main-hero" >
	<h1 id="hero-text">Welcome to Edgefinity <span class="text-primary">IoT</span></h1>
</div>
<div class="dashboard-section">
	<div class="row">
  <!-- PVH -->
		<div *ngIf="pagePermissionService.canRead(pagePermissionType.PvhScanChamber)" class="col-sm-4">
			<div [routerLink]="['/pvh/scan-chamber/select-chamber']" class="panel panel-default dashboard-panel">
				<div id="pvh-scan-chamber" class="panel-heading dashboard-header"></div>
				<div class="panel-body dashboard-panel-body">
					<h3><i class="fa fa-building-o" aria-hidden="true"></i> PVH: Scan Chamber</h3>
					<p>Validates a single Carton.</p>
				</div>
				<div class="panel-footer">
					<button type="button" class="btn btn-primary btn-xs">Validate Carton</button>
				</div>
			</div>
		</div>
  <!-- END: PVH-->
	<!-- 	KISS	 -->
		<div *ngIf="pagePermissionService.canRead(pagePermissionType.DemoOrderPortalValidationPage)" class="col-sm-4">
			<div [routerLink]="['/order/portal-validation/select-portal']" class="panel panel-default dashboard-panel">
				<div id="demo-order-portal-validation" class="panel-heading dashboard-header"></div>
				<div class="panel-body dashboard-panel-body">
					<h3><i class="fa fa-building-o" aria-hidden="true"></i> ORDER PORTAL VALIDATION</h3>
					<p>Validate Orders using a Portal.</p>
				</div>
				<div class="panel-footer">
					<button type="button" class="btn btn-primary btn-xs">Validate Orders</button>
				</div>
			</div>
		</div>
		<div *ngIf="pagePermissionService.canRead(pagePermissionType.CartonAuditPortalPage)" class="col-sm-4">
			<div [routerLink]="['/jockey/carton-audit/select-location']" class="panel panel-default dashboard-panel">
				<div id="carton-audit-portal" class="panel-heading dashboard-header"></div>
				<div class="panel-body dashboard-panel-body">
					<h3><i class="fa fa-building-o" aria-hidden="true"></i> CARTON AUDIT </h3>
					<p>Audit cartons.</p>
				</div>
				<div class="panel-footer">
					<button type="button" class="btn btn-primary btn-xs">Carton Audit</button>
				</div>
			</div>
		</div>
		<div *ngIf="pagePermissionService.canRead(pagePermissionType.KissPrintPage)" class="col-sm-4">
			<div [routerLink]="['/kiss/print']" class="panel panel-default dashboard-panel">
				<div id="kiss-print" class="panel-heading dashboard-header"></div>
				<div class="panel-body dashboard-panel-body">
					<h3><i class="fa fa-print" aria-hidden="true"></i> PRINT</h3>
					<p>Print PO Labels from SAP.</p>
				</div>
				<div class="panel-footer">
					<button type="button" class="btn btn-primary btn-xs">Print PO</button>
				</div>
			</div>
		</div>
		<div *ngIf="pagePermissionService.canRead(pagePermissionType.KissPortalValidationPage)" class="col-sm-4">
			<div [routerLink]="['/kiss/portal-validation/select-portal']" class="panel panel-default dashboard-panel">
				<div id="kiss-portal-validation" class="panel-heading dashboard-header"></div>
				<div class="panel-body dashboard-panel-body">
					<h3><i class="fa fa-building-o" aria-hidden="true"></i> VALIDATION</h3>
					<p>Validate RFID Tags.</p>
				</div>
				<div class="panel-footer">
					<button type="button" class="btn btn-primary btn-xs">Portal Validation</button>
				</div>
			</div>
		</div>
		<div *ngIf="pagePermissionService.canRead(pagePermissionType.KissOutboundValidationPage)" class="col-sm-4">
			<div [routerLink]="['/kiss/outbound-validation/select-portal']" class="panel panel-default dashboard-panel">
				<div id="kiss-outbound-validation" class="panel-heading dashboard-header"></div>
				<div class="panel-body dashboard-panel-body">
					<h3><i class="fa fa-building-o" aria-hidden="true"></i> OUTBOUND VALIDATION</h3>
					<p>Validate RFID Tags for Outbound.</p>
				</div>
				<div class="panel-footer">
					<button type="button" class="btn btn-primary btn-xs">Outbound Validation</button>
				</div>
			</div>
		</div>
		<!-- 	End KISS 	-->
		<!--	Denver Mattress 	-->
		<div *ngIf="pagePermissionService.canRead(pagePermissionType.DenverMattressPortalValidationPage)" class="col-sm-4">
			<div [routerLink]="['/denver-mattress/portal-validation/select-portal']" class="panel panel-default dashboard-panel">
				<div id="denver-mattress-portal-validation" class="panel-heading dashboard-header"></div>
				<div class="panel-body dashboard-panel-body">
					<h3><i class="fa fa-building-o" aria-hidden="true"></i> DENVER ORDER PORTAL VALIDATION</h3>
					<p>Validate Orders using a Portal.</p>
				</div>
				<div class="panel-footer">
					<button type="button" class="btn btn-primary btn-xs">Validate Orders</button>
				</div>
			</div>
		</div>
		<!-- 	End Denver Mattress 	-->
		<!--	Buchanan 	-->
		<div *ngIf="pagePermissionService.canRead(pagePermissionType.BuchananPrintPage)" class="col-sm-4">
			<div [routerLink]="['/buchanan/print']" class="panel panel-default dashboard-panel">
				<div id="buchanan-print" class="panel-heading dashboard-header"></div>
				<div class="panel-body dashboard-panel-body">
					<h3><i class="fa fa-print" aria-hidden="true"></i> Buchanan: Print</h3>
					<p>Prints label(s) for a specified Item Code.</p>
				</div>
				<div class="panel-footer">
					<button type="button" class="btn btn-primary btn-xs">Print</button>
				</div>
			</div>
		</div>
		<div *ngIf="pagePermissionService.canRead(pagePermissionType.BuchananBulkPrintPage)" class="col-sm-4">
			<div [routerLink]="['/buchanan/bulk-print']" class="panel panel-default dashboard-panel">
				<div id="buchanan-bulk-print" class="panel-heading dashboard-header"></div>
				<div class="panel-body dashboard-panel-body">
					<h3><i class="fa fa-print" aria-hidden="true"></i> Buchanan: Bulk Print</h3>
					<p>Prints label(s) from a CSV File.</p>
				</div>
				<div class="panel-footer">
					<button type="button" class="btn btn-primary btn-xs">Bulk Print</button>
				</div>
			</div>
		</div>
		<div *ngIf="pagePermissionService.canRead(pagePermissionType.BuchananUploadProductPage)" class="col-sm-4">
			<div [routerLink]="['/buchanan/upload-product']" class="panel panel-default dashboard-panel">
				<div id="buchanan-upload-product" class="panel-heading dashboard-header"></div>
				<div class="panel-body dashboard-panel-body">
					<h3><i class="fa fa-file" aria-hidden="true"></i> Buchanan: Upload Product</h3>
					<p>Uploads Product Information from a CSV File.</p>
				</div>
				<div class="panel-footer">
					<button type="button" class="btn btn-primary btn-xs">Upload Product</button>
				</div>
			</div>
		</div>
		<!-- 	End Buchanan	-->
		<!--	O'Neil      	-->
		<div *ngIf="pagePermissionService.canRead(pagePermissionType.ONeilCartonPortalPages)" class="col-sm-4">
			<div [routerLink]="['/oneill/carton-portal-validation/select-portal']" class="panel panel-default dashboard-panel">
				<div id="denver-mattress-portal-validation" class="panel-heading dashboard-header"></div>
				<div class="panel-body dashboard-panel-body">
					<h3><i class="fa fa-building-o" aria-hidden="true"></i> O'NEILL CARTON PORTAL VALIDATION</h3>
					<p>Validate Cartons using a Portal.</p>
				</div>
				<div class="panel-footer">
					<button type="button" class="btn btn-primary btn-xs">Validate Cartons</button>
				</div>
			</div>
		</div>
		<!-- 	End O'Neil     	-->
		<!--   Start AbleNet 	-->
		<div *ngIf="pagePermissionService.canRead(pagePermissionType.AbleNetShipmentValidationPage)" class="col-sm-4">
			<div [routerLink]="['/ablenet/shipment-validation/select-service']" class="panel panel-default dashboard-panel">
				<div id="ablenet-shipment-validation" class="panel-heading dashboard-header"></div>
				<div class="panel-body dashboard-panel-body">
					<h3><i class="fa fa-building-o" aria-hidden="true"></i> ABLENET SHIPMENT VALIDATION</h3>
					<p>Validate Shipment Information using the Portal.</p>
				</div>
				<div class="panel-footer">
					<button type="button" class="btn btn-primary btn-xs">Validate Orders</button>
				</div>
			</div>
		</div>
		<div *ngIf="pagePermissionService.canRead(pagePermissionType.AbleNetReturnDevicesValidationPage)" class="col-sm-4">
			<div [routerLink]="['/ablenet/return-devices/select-service']" class="panel panel-default dashboard-panel">
				<div id="ablenet-return-devices-validation" class="panel-heading dashboard-header"></div>
				<div class="panel-body dashboard-panel-body">
					<h3><i class="fa fa-building-o" aria-hidden="true"></i> ABLENET RETURN DEVICES VALIDATION</h3>
					<p>Validate Return Devices Information using the Portal.</p>
				</div>
				<div class="panel-footer">
					<button type="button" class="btn btn-primary btn-xs">Validate Returns</button>
				</div>
			</div>
		</div>
				<div *ngIf="pagePermissionService.canRead(pagePermissionType.AbleNetExpReturnDevicesValidationPage)" class="col-sm-4">
			<div [routerLink]="['/ablenet/exp-return-devices/select-service']" class="panel panel-default dashboard-panel">
				<div id="ablenet-return-devices-validation" class="panel-heading dashboard-header"></div>
				<div class="panel-body dashboard-panel-body">
					<h3><i class="fa fa-building-o" aria-hidden="true"></i> ABLENET: AbleEXP RETURN DEVICES VALIDATION</h3>
					<p>Validate AbleExp Return Devices Information using the Portal.</p>
				</div>
				<div class="panel-footer">
					<button type="button" class="btn btn-primary btn-xs">Validate Returns</button>
				</div>
			</div>
		</div>
		<!--   END AbleNet   -->
		<div *ngIf="pagePermissionService.canRead(pagePermissionType.LocatePage)" class="col-sm-4">
			<div [routerLink]="['/locate']" class="panel panel-default dashboard-panel">
				<div id="locate" class="panel-heading dashboard-header"></div>
				<div class="panel-body dashboard-panel-body">
					<h3><i class="fa fa-search" aria-hidden="true"></i> LOCATE</h3>
					<p>Find something or someone.</p>
				</div>
				<div class="panel-footer">
					<button type="button" class="btn btn-primary btn-xs">View Locations</button>
				</div>
			</div>
		</div>
		<div *ngIf="pagePermissionService.canRead(pagePermissionType.MonitorLocationPage)" class="col-sm-4">
			<div [routerLink]="['/monitor-location']" class="panel panel-default dashboard-panel">
				<div id="monitor-locations" class="panel-heading dashboard-header"></div>
				<div class="panel-body dashboard-panel-body">
					<h3><i class="fa fa-search" aria-hidden="true"></i> MONITOR LOCATION </h3>
					<p>Monitor a Location</p>
				</div>
				<div class="panel-footer">
					<button type="button" class="btn btn-primary btn-xs">View Locations</button>
				</div>
			</div>
		</div>
		<div *ngIf="pagePermissionService.canRead(pagePermissionType.MonitorZonePage)" class="col-sm-4">
			<div [routerLink]="['/monitor-zone']" class="panel panel-default dashboard-panel">
				<div id="monitor-zones" class="panel-heading dashboard-header"></div>
				<div class="panel-body dashboard-panel-body">
					<h3><i class="fa fa-search" aria-hidden="true"></i> MONITOR ZONE </h3>
					<p>Monitor a Zone</p>
				</div>
				<div class="panel-footer">
					<button type="button" class="btn btn-primary btn-xs">View Zones</button>
				</div>
			</div>
		</div>
		<div *ngIf="pagePermissionService.canRead(pagePermissionType.MonitorAssetsPage)" class="col-sm-4">
			<div [routerLink]="['/monitor-assets']" class="panel panel-default dashboard-panel">
				<div  id="monitor-assets"class="panel-heading dashboard-header"></div>
				<div class="panel-body dashboard-panel-body">
					<h3><i class="fa fa-search" aria-hidden="true"></i> MONITOR ASSETS </h3>
					<p>Monitor Assets</p>
				</div>
				<div class="panel-footer">
					<button type="button" class="btn btn-primary btn-xs">View Assets</button>
				</div>
			</div>
		</div>
		<div *ngIf="pagePermissionService.canRead(pagePermissionType.MonitorTagsPage)" class="col-sm-4">
			<div [routerLink]="['/monitor-tags']" class="panel panel-default dashboard-panel">
				<div id="monitor-tags" class="panel-heading dashboard-header"></div>
				<div class="panel-body dashboard-panel-body">
					<h3><i class="fa fa-search" aria-hidden="true"></i> MONITOR TAGS </h3>
					<p>Monitor Tags</p>
				</div>
				<div class="panel-footer">
					<button type="button" class="btn btn-primary btn-xs">View Tags</button>
				</div>
			</div>
		</div>
		<div *ngIf="pagePermissionService.canRead(pagePermissionType.HistoryPage)" class="col-sm-4">
			<div [routerLink]="['/history']" class="panel panel-default dashboard-panel">
				<div id="history" class="panel-heading dashboard-header"></div>
				<div class="panel-body dashboard-panel-body">
					<h3><i class="fa fa-history" aria-hidden="true"></i> HISTORY</h3>
					<p>View past movement/events.</p>
				</div>
				<div class="panel-footer">
					<button type="button" class="btn btn-primary btn-xs">Review History</button>
				</div>
			</div>
		</div>
		<div *ngIf="pagePermissionService.canRead(pagePermissionType.SecurityPage)" class="col-sm-4">
			<div [routerLink]="['/security']" class="panel panel-default dashboard-panel">
				<div id="security" class="panel-heading dashboard-header"></div>
				<div class="panel-body dashboard-panel-body">
					<h3><i class="fa fa-eye" aria-hidden="true"></i> SECURITY</h3>
					<p>Monitor incoming alerts.</p>
				</div>
				<div class="panel-footer">
					<button type="button" class="btn btn-primary btn-xs">Check Security</button>
				</div>
			</div>
		</div>
		<div *ngIf="pagePermissionService.canRead(pagePermissionType.SettingsPage)" class="col-sm-4">
			<div [routerLink]="['/settings']" class="panel panel-default dashboard-panel">
				<div id="admin-settings" class="panel-heading dashboard-header"></div>
				<div class="panel-body dashboard-panel-body">
					<h3><i class="fa fa-wrench" aria-hidden="true"></i> ADMIN SETTINGS</h3>
					<p>Configure system settings.</p>
				</div>
				<div class="panel-footer">
					<button type="button" class="btn btn-primary btn-xs">View Settings</button>
				</div>
			</div>
		</div>
		<div *ngIf="pagePermissionService.canRead(pagePermissionType.ReportsPage)" class="col-sm-4">
			<div (click)="onReports()" class="panel panel-default dashboard-panel">
				<div id="reports" class="panel-heading dashboard-header"></div>
				<div class="panel-body dashboard-panel-body">
					<h3><i class="fa fa-file" aria-hidden="true"></i> REPORTS</h3>
					<p>Generate reports.</p>
				</div>
				<div class="panel-footer">
					<button type="button" class="btn btn-primary btn-xs">Generate Reports</button>
				</div>
			</div>
		</div>
		
		<div *ngIf="pagePermissionService.canRead(pagePermissionType.HelpPage)" class="col-sm-4">
			<div class="panel panel-default dashboard-panel">
				<div id="help" class="panel-heading dashboard-header"></div>
				<div class="panel-body dashboard-panel-body">
					<h3><i class="fa fa-question" aria-hidden="true"></i> HELP</h3>
					<p>View our user guide.</p>
				</div>
				<div class="panel-footer">
					<button type="button" class="btn btn-primary btn-xs">Open User Guide</button>
				</div>
			</div>
		</div>

<!--
  <div *ngIf="pagePermissionService.canRead(pagePermissionType.HealthMonitorPage)" class="col-sm-4">
    <div [routerLink]="['/healthMonitor']" class="panel panel-default dashboard">
      <div class="panel-body dashboard-panel">
        <i class="fa fa-heartbeat fa-4x" aria-hidden="true"></i>
        <h3>HEALTH MONITOR</h3>
        <p>View System Health Monitor</p>
      </div>
    </div>
  </div>
-->
</div>
</div>
